import React from 'react';
import './fit-bars.css';

// Fit bars (Kaan, 5 Kasım 2026; replaces the radial heatmap): one row per criterion with a three-part bar, the level
// word and what was compared. Values are 0..1 or null; unknown rows stay in the list, muted, with an empty bar.
export const fitLevel = value => value == null ? 0 : value >= 2 / 3 ? 3 : value >= 1 / 3 ? 2 : value > 0 ? 1 : 0;
export const fitWord = value => value == null ? 'Bilinmiyor' : value >= 2 / 3 ? 'Güçlü' : value >= 1 / 3 ? 'Kısmen' : 'Zayıf';

export function FitBars({ items = [], label = 'Uygunluk ölçütleri', className = '' }) {
  return <ul className={`bs-fit-bars ${className}`.trim()} aria-label={label}>
    {items.map(item => {
      const unknown = item.value == null, level = fitLevel(item.value);
      return <li key={item.id} className="bs-fit-row" data-level={unknown ? 'unknown' : level}>
        <span className="bs-fit-label">{item.label}</span>
        <span className="bs-fit-bar" role="img" aria-label={`${item.label}: ${fitWord(item.value)}`}>{[1, 2, 3].map(n => <i key={n} className={!unknown && n <= level ? 'is-on' : ''} />)}</span>
        <strong className="bs-fit-word">{fitWord(item.value)}</strong>
        {item.detail && <span className="bs-fit-detail">{item.detail}</span>}
      </li>;
    })}
  </ul>;
}
